import { types } from "../types";
import momentTZ from 'moment-timezone';
import history from '../../commons/history';
import layout from '../requests/layout.requests';
import LayoutAction from '../actions/LayoutAction';
import localStorage from '../../utils/localStorage';
import { jwtToken } from '../../commons/jwtTokenExpiry';
import { takeLatest, call, put } from 'redux-saga/effects';

export function* getUserProfileSaga() {
  try {
    const userProfileSagaSuccess = yield call(layout.getUserprofile);
    if (userProfileSagaSuccess.name === 'JsonWebTokenError') {
      localStorage.clear();
      history.push('/login');
      window.location.reload();
    } else if (userProfileSagaSuccess.message === 'User is not permitted to this resource') {
      jwtToken(userProfileSagaSuccess.message);
    } else if (userProfileSagaSuccess.statusCode === 400) {
      jwtToken(userProfileSagaSuccess.message);
    } else {
      if (
        userProfileSagaSuccess &&
        userProfileSagaSuccess.belongsTo &&
        userProfileSagaSuccess.belongsTo.sites
      ) {
        let roleItems =
          userProfileSagaSuccess.belongsTo.sites[
            Object.keys(userProfileSagaSuccess.belongsTo.sites)[0]
          ].role;
        let landingPage =
          userProfileSagaSuccess.belongsTo.sites[
            Object.keys(userProfileSagaSuccess.belongsTo.sites)[0]
          ].role.LandingPageId;
        let hierarchy =
          userProfileSagaSuccess.belongsTo.sites[
            Object.keys(userProfileSagaSuccess.belongsTo.sites)[0]
          ].hierarchy;
        let defaultHierarchy =
          userProfileSagaSuccess.belongsTo.sites[
            Object.keys(userProfileSagaSuccess.belongsTo.sites)[0]
          ].defaultHierarchy;
        let userDetails = userProfileSagaSuccess.user;
        let menuHierarchy = {
          ApplicationSettings: roleItems.ApplicationSettings,
          Modules: roleItems.Modules,
          Configuration: roleItems.Configuration,
          hierarchy
        };
        let sessionTime = userDetails.SessionTime || 30;
        localStorage.set('currentSite', Object.keys(userProfileSagaSuccess.belongsTo.sites)[0]);
        localStorage.set('modules', JSON.stringify(menuHierarchy));
        localStorage.set('role', roleItems.Name);
        localStorage.set('roleId', JSON.stringify(roleItems.Id));
        localStorage.set('landingPage', landingPage);
        yield put(LayoutAction.setMenuHierarchy(menuHierarchy));
        yield put(LayoutAction.setLandingPage(landingPage));
        yield put(LayoutAction.setUserDetails(userDetails));
        yield put(LayoutAction.setTimeZone(momentTZ.tz.guess()));
        yield put(LayoutAction.setDefaultHierarchy(defaultHierarchy));
        yield put(LayoutAction.setuserTimeout(sessionTime));
      }
      yield put(LayoutAction.getLoggedInProfileSuccess(userProfileSagaSuccess));
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* layoutSaga() {
  yield takeLatest(types.GET_LOGGEDIN_PROFILE, getUserProfileSaga);
}
